import { useContext } from 'react';

import { LockContext } from './LockContext';

export const useLock = () => {
  return useContext(LockContext);
};
